<template>
  <categorical-insight-container v-if="values.length" :columns="2">
    <b-card :style="style">
      <h6 class="text-center mb-2">Common Segment Attributes</h6>
      <b-table
        small
        striped
        hover
        head-variant="dark"
        :items="values"
        :fields="['#', 'field', 'value', {key: 'count', class: 'text-right'}]">
        <template v-slot:cell(#)="data">
          {{ data.index + 1 }}
        </template>
        <template v-slot:cell(value)="data">
          {{ valueLabel(data.value) }}
        </template>

        <template v-slot:cell(count)="data">
          {{ data.value | formatInt }}
        </template>
      </b-table>
    </b-card>
  </categorical-insight-container>
</template>

<script>
  import CategoricalInsightContainer from './CategoricalInsightContainer';
  import {maybeMissingValueLabel} from './utils';

  export default {
    name: 'SingleValueInsights',

    components: {CategoricalInsightContainer},

    props: {
      values: Array
    },

    watch: {
      values(v) {
        console.log(v);
      }
    },

    data() {
      return {
        valueLabel: maybeMissingValueLabel
      };
    },

    computed: {
      style() {
        return {
          maxHeight: "100%",
          overflowY: 'auto',
          borderRadius: 4
        };
      }
    }
  };
</script>

<style scoped>

</style>
